import { render, staticRenderFns } from "./02-IDType.vue?vue&type=template&id=d7297e1a&scoped=true&"
import script from "./02-IDType.vue?vue&type=script&lang=js&"
export * from "./02-IDType.vue?vue&type=script&lang=js&"
import style0 from "./02-IDType.vue?vue&type=style&index=0&id=d7297e1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7297e1a",
  null
  
)

export default component.exports